var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_120_1133)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 17,
    r: 17,
    fill: "#AE7EEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0041 16.7122C14.0521 16.5971 14.115 16.4554 14.1942 16.2939C14.4249 15.8235 14.7878 15.1973 15.3138 14.5746C16.3538 13.3432 18.0193 12.1302 20.6331 12.1302C23.2468 12.1302 24.9123 13.3432 25.9524 14.5746C26.4784 15.1973 26.8413 15.8235 27.0719 16.2939C27.1527 16.4586 27.2165 16.6027 27.2649 16.7189C27.2154 16.8321 27.1506 16.9718 27.0691 17.1311C26.8336 17.5915 26.4649 18.2034 25.9355 18.8093C24.8888 20.0073 23.2262 21.1765 20.6494 21.1343C18.0511 21.0918 16.3743 19.9106 15.3248 18.7306C14.7945 18.1344 14.4261 17.5387 14.1914 17.0933C14.1143 16.947 14.0523 16.818 14.0041 16.7122ZM28.3367 16.7283C29.291 16.4295 29.2909 16.429 29.2907 16.4285L29.2903 16.4274L29.2895 16.4248L29.2874 16.4181L29.281 16.3986C29.2759 16.383 29.2688 16.3621 29.2598 16.3363C29.2418 16.2847 29.216 16.2134 29.1817 16.1252C29.1131 15.9489 29.0102 15.7041 28.8677 15.4134C28.5837 14.8341 28.1364 14.0608 27.4803 13.284C26.1562 11.7164 23.9699 10.1302 20.6331 10.1302C17.2963 10.1302 15.1099 11.7164 13.7858 13.284C13.1297 14.0608 12.6825 14.8341 12.3985 15.4134C12.2559 15.7041 12.153 15.9489 12.0844 16.1252C12.0501 16.2134 12.0243 16.2847 12.0063 16.3363C11.9973 16.3621 11.9903 16.383 11.9851 16.3986L11.9788 16.4181L11.9766 16.4248L11.9758 16.4274L11.9754 16.4285C11.9753 16.429 11.9751 16.4295 12.9294 16.7283L11.9751 16.4295L11.877 16.743L11.9839 17.0537L12.9294 16.7283C11.9839 17.0537 11.984 17.0542 11.9842 17.0547L11.9846 17.0558L11.9855 17.0583L11.9878 17.0649L11.9945 17.0838C12 17.0989 12.0074 17.1191 12.0169 17.1438C12.0357 17.1933 12.0627 17.2616 12.0983 17.3459C12.1695 17.5145 12.2758 17.7482 12.4221 18.0257C12.7136 18.5789 13.1693 19.3165 13.8304 20.0598C15.1635 21.5587 17.3385 23.0804 20.6167 23.1341C23.9165 23.188 26.1057 21.6542 27.4416 20.1253C28.1036 19.3677 28.559 18.6102 28.8496 18.042C28.9955 17.7568 29.1015 17.5163 29.1723 17.343C29.2078 17.2563 29.2346 17.1862 29.2532 17.1354C29.2626 17.11 29.2699 17.0894 29.2753 17.074L29.2819 17.0547L29.2842 17.0481L29.2854 17.0444C29.2856 17.044 29.2857 17.0435 28.3367 16.7283ZM28.3367 16.7283L29.2857 17.0435L29.3874 16.7373L29.291 16.4295L28.3367 16.7283ZM20.6331 15.7822C20.0958 15.7822 19.7072 16.1991 19.7072 16.6562C19.7072 17.1134 20.0958 17.5303 20.6331 17.5303C21.1703 17.5303 21.559 17.1134 21.559 16.6562C21.559 16.1991 21.1703 15.7822 20.6331 15.7822ZM17.7072 16.6562C17.7072 15.0434 19.0431 13.7822 20.6331 13.7822C22.2231 13.7822 23.559 15.0434 23.559 16.6562C23.559 18.2691 22.2231 19.5303 20.6331 19.5303C19.0431 19.5303 17.7072 18.2691 17.7072 16.6562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_120_1133",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_1133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_1133",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeButton);
export default __webpack_public_path__ + "static/media/EyeButton.4b39560958c0bfbb1d2bebdb48b10a01.svg";
export { ForwardRef as ReactComponent };